import React from 'react';
import { observer } from 'mobx-react';
import { Navigate, Route, Routes } from 'react-router-dom';
import styled from 'styled-components';

import EnergySavingsPage from './EnergySavingsPage';
import EnergySavingsPowerPage from './EnergySavingsPowerPage';
import InsightsReportPage from './InsightsReportPage';
import LeakageReportPage from './LeakageReportPage';
import OpenInsightsReportPage from './OpenInsightsReportPage';

const ValueDashboardReportPage = observer(() => {
  return (
    <Container>
      <div className="page-container">
        <Routes>
          <Route path="energy-savings" element={<EnergySavingsPage />} />
          <Route path="energy-savings-power" element={<EnergySavingsPowerPage />} />
          <Route path="leakage" element={<LeakageReportPage />} />
          <Route path="insights" element={<InsightsReportPage />} />
          <Route path="open-insights" element={<OpenInsightsReportPage />} />

          <Route path="*" element={<Navigate replace to="energy-savings" />} />
        </Routes>
      </div>
    </Container>
  );
});

const Container = styled.div``;
export default ValueDashboardReportPage;
